import React from "react";
import { Button, Dropdown, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { getUserPermissions } from "../../../app/common/util/genericUtils";
import { ORDER_TYPES } from "../../../app/common/util/genericConstants";

const UtilMenus = ({ openModal }) => {
  const userPermissions = getUserPermissions() || [];
  const canPunchOrder = userPermissions.includes("can_punch_order");
  const canBroadcast = userPermissions.includes("can_broadcast_notifications");
  const canViewWhatsapp = userPermissions.includes("can_view_whatsapp_orders");
  const canBlankSelect = userPermissions.includes("can_do_blankselection");
  const canLinkOrder = userPermissions.includes("can_link_order");

  return (
    <div className="home-util-menus">
      {canPunchOrder && (
        <Button
          as={Link}
          to={`/create/${ORDER_TYPES.RX}`}
          className="util-menu-btn util-menu-btn-rx util-action-btn util-action-btn-rx"
        >
          <Icon name="file alternate outline" />
          <span>New Rx Order</span>
        </Button>
      )}

      <Dropdown
        button
        pointing="top right"
        className="util-menu-btn util-menu-more-actions util-action-btn util-action-btn-more"
        icon={null}
        trigger={
          <span className="util-action-trigger">
            <Icon name="th large" />
            <span>More Actions</span>
            <Icon name="chevron down" className="util-action-chevron" />
          </span>
        }
      >
        <Dropdown.Menu className="util-menu-dropdown-menu">
          {canBroadcast && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-dropdown-item-desktop-only util-menu-item-olive"
              onClick={() => openModal("CreateNotificationModal")}
            >
              <Icon name="bell outline" />
              Create Notification
            </Dropdown.Item>
          )}
          {canPunchOrder && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-item-teal"
              as={Link}
              to={`/create/${ORDER_TYPES.STOCK_SINGLE}`}
            >
              <Icon name="box" />
              New Stock Order
            </Dropdown.Item>
          )}
          {canPunchOrder && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-dropdown-item-desktop-only util-menu-item-teal"
              as={Link}
              to={`/create/${ORDER_TYPES.STOCK_MULTI}`}
            >
              <Icon name="boxes" />
              New Multi Stock Order
            </Dropdown.Item>
          )}
          {canPunchOrder && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-dropdown-item-desktop-only util-menu-item-blue"
              onClick={() => openModal("BulkOrderModal")}
            >
              <Icon name="upload" />
              Create Bulk Order
            </Dropdown.Item>
          )}
          {canViewWhatsapp && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-dropdown-item-desktop-only util-menu-item-green"
              onClick={() => openModal("WhatsappModal")}
            >
              <Icon name="whatsapp" />
              WhatsApp Orders
            </Dropdown.Item>
          )}
          {canBlankSelect && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-dropdown-item-desktop-only util-menu-item-brown"
              onClick={() => openModal("OrderSelectionModal")}
            >
              <Icon name="check square outline" />
              Blank Selection
            </Dropdown.Item>
          )}
          {canLinkOrder && (
            <Dropdown.Item
              className="util-menu-dropdown-item util-menu-item-purple"
              onClick={() => openModal("LinkedOrderModal")}
            >
              <Icon name="linkify" />
              New Linked Order
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default UtilMenus;
